import actionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';

export const reducers = {
  query: createAsyncRequestReducer(actionTypes.FETCH_CLIENTS),
  create: createAsyncRequestReducer(actionTypes.CREATE_CLIENT),
  update: createAsyncRequestReducer(actionTypes.UPDATE_CLIENT),
  delete: createAsyncRequestReducer(actionTypes.DELETE_CLIENT),
};

export default combineReducers(reducers);
